<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17HSgmk/tc-custom/9781460327388.jpg?1731166484184" alt="This image is the cover for the book Lassoed by Fortune, The Fortunes of Texas: Welcome to Horseback Hollow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lassoed by Fortune, The Fortunes of Texas: Welcome to Horseback Hollow
      </h1>
      <p class="bookDescription body article font2">
        <b>Opposites attract when a woman challenges a traditional cowboy to change his ways, in this western romance from a <i>USA Today</i>–bestselling author.</b><br/><br/>Liam “Fortune” Jones knows exactly who and what he is: the son of Deke Jones, born and bred in Horseback Hollow. He is an old-fashioned cowboy, committed to tradition and used to getting his own way. And he won’t change for anyone—not even for the sassy aspiring chef who’s been tormenting his dreams.<br/><br/>Julia Tierney holds the distinction of being the only woman who ever turned Liam down. She’s an independent lady with dreams way bigger than their rustic hometown. Every time she runs into that bullheaded rancher, they bicker. The man makes her nuts! But there’s something about Liam that keeps roping her in and making her come back for more.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marie Ferrarella
      </h2>
      
      <p class="authorDescription body article">This USA TODAY bestselling and RITA &reg; Award-winning author has written more than two hundred books for Harlequin Books and Silhouette Books, some under the name Marie Nicole. Her romances are beloved by fans worldwide. Visit her website at www.marieferrarella.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f3e069c